import { HttpInterceptorFn } from '@angular/common/http';
import { LoadingService } from '../services/is-loading/loading.service';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

export const SKIP_LOADING_HEADER = 'x-skip-loading';

export const loadingHandlerInterceptor: HttpInterceptorFn = (req, next) => {
    const loadingService = inject(LoadingService);
    const skipLoading = req.headers.has(SKIP_LOADING_HEADER);

    if (!skipLoading) {
        loadingService.show();
    }

    const reqWithoutHeader = skipLoading
        ? req.clone({ headers: req.headers.delete(SKIP_LOADING_HEADER) })
        : req;

    return next(reqWithoutHeader).pipe(
        finalize(() => {
            if (!skipLoading) {
                loadingService.hide();
            }
        })
    );
};
